import type { NestedStringRecord } from './NestedStringRecord.d';
import { isStringLiteral } from '@enonic/js-utils/value/isStringLiteral';

/**
 * Type-safe, ESLint-friendly Object.values() ponyfill
 * - Uses Record instead of index signatures
 * - No `any`, no unsafe casts, no unsafe returns
 * - Matches native Object.values behavior exactly
 */
function values<T>(obj: Record<string, T> | ArrayLike<T>): T[];
function values(obj: object): unknown[];
function values(obj: object): unknown[] {
	if (obj == null) {
		throw new TypeError('Object.values called on non-object');
	}

	// Object.keys returns string[] – safe to index with string on any object
	// We cast obj to Record<string, unknown> only for the lookup – this is safe
	// because Object.keys only returns own enumerable string keys.
	const keys = Object.keys(obj) as string[];

	return keys.map((key) => (obj as Record<string, unknown>)[key]) as unknown[];
}


export function getLeafStrings(obj: NestedStringRecord): string[] {
	const leaves: string[] = [];

	function traverse(node: NestedStringRecord): void {
		if (isStringLiteral(node)) {
			leaves.push(node);
			return;
		}

		if (Array.isArray(node)) {
			node.forEach(traverse);
		} else {
			(values(node) as NestedStringRecord[]).forEach(traverse);
		}
	}

	traverse(obj);
	return leaves;
}
